import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeartbeat, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import './App.css';
import bwImage from './IMG/bw.jpg';
import cap from './IMG/cap.jpg';
import ironman from './IMG/ironman.jpg';
import DR1 from './IMG/DR1.webp';
import DR2 from './IMG/DR2.jpg';
import DR3 from './IMG/DR3.avif';
import DR4 from './IMG/DR4.jpeg';

function App() {
    const [isMenuActive, setIsMenuActive] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
      const handleScroll = () => {
        setIsMenuActive(false);
      };
  
      window.addEventListener('scroll', handleScroll);
  
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);
  
    const toggleMenu = () => {
      setIsMenuActive(!isMenuActive);
    };

    const navigateToServices = () => {
      navigate('/services');
      window.scrollTo(0, 0);  // Add this line to reset scroll position

    };
    const navigateToBTracker = () => {
        navigate('/BookingTracker');
        window.scrollTo(0, 0);  // Add this line to reset scroll position
  
      };
      
  return (
    <html lang="en">

<head>
    <meta charset="UTF-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Hospital Website</title>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css" />
    <link rel="stylesheet" href="css/style.css" />
</head>

<body>
<header className="header">
        <a href="#" className="logo">
          <FontAwesomeIcon icon={faHeartbeat} /> Hospital
        </a>
        <nav className={`navbar ${isMenuActive ? 'active' : ''}`}>
          <a href="#home">home</a>
          <a href="#services">services</a>
          <a href="#about">about</a>
          <a href="#doctors">doctors</a>
          <a href="#book">book</a>
          <a href="#review">review</a>
          <a href="#Payments">Payments</a>
        </nav>
        
        <button id="menu-btn" class="fas fa-bars" onClick={toggleMenu} className={isMenuActive ? 'fa-times' : ''}>
        <FontAwesomeIcon icon={isMenuActive ? faTimes : faHeartbeat} /></button>
      </header>
    <section class="home" id="home">
        <div class="image">
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQEYaXECYnFyVRQK8TDnbbEJgUdEP1jAgnpDg&usqp=CAU"
                alt="" />
        </div>
        <div class="content">
            <h3>Medicines cure Diseases,But Doctors Can Cure Patients</h3>
            <p>
                 has set up a special cell for patients from overseas seeking
                treatment at its facilities. Now, it is looking forward to extending
                its surgical skills in different parts of the nation and the globe by
                the way of association with hospitals and institutes having similar
                kind of dedication and zeal towards 'Patient Care'.
            </p>
            <a 
                href="#footer" 
                className="btn"
                onClick={(e) => {
                    e.preventDefault();
                    const footerSection = document.querySelector('.footer');
                    if (footerSection) {
                    footerSection.scrollIntoView({ behavior: 'smooth' });
                    }
                }}
                >
                contact us <span className="fas fa-chevron-right"></span>
                </a>
                <p></p>
            <button id="SER-btn" className="btn" onClick={navigateToBTracker}>BookingTracker<span class="fas fa-chevron-right"> </span></button>

        </div>
    </section>
    <section class="icons-container">
        <div class="icons">
            <i class="fas fa-user-md"></i>
            <h3>180+</h3>
            <p>Docors on Duty</p>
        </div>
        <div class="icons">
            <i class="fas fa-users"></i>
            <h3>2300+</h3>
            <p>Satisfied patients</p>
        </div>
        <div class="icons">
            <i class="fas fa-procedures"></i>
            <h3>700+</h3>
            <p>Bed facility</p>
        </div>
        <div class="icons">
            <i class="fas fa-hospital"></i>
            <h3>70+</h3>
            <p>available hospitals</p>
        </div>
    </section>
    <section class="services" id="services">
        <h1 class="heading">our <span>services</span></h1>
        <div class="box-container">
        <div class="box">
        <i class="fas fa-ambulance"></i>

                        <h3>DOORSTEP SERVICES</h3>
                <p>
                We provide efficient and cost-
effective primary health care
services at your door step.
Our motto is to take
primary health care
services to the community
where it is needed the most.
                </p>
                {/* <a href=" " target="_blank" class="btn" >
                   <span class="fas fa-chevron-right"> </span>
                </a> */}
                <button id="SER-btn" className="btn" onClick={navigateToServices}> Book Service<span class="fas fa-chevron-right"> </span></button>
            </div>
            <div class="box">
                <i class="fas fa-notes-medical"></i>
                <h3>free checkups</h3>
                <p>
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ad, omnis.
                </p>
                <a href=" " target="_blank" class="btn">
                    learn more <span class="fas fa-chevron-right"></span>
                </a>
            </div>
            <div class="box">
                <i class="fas fa-ambulance"></i>
                <h3>24/7 ambulance</h3>
                <p>
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ad, omnis.
                </p>
                <a href=" " target="_blank" class="btn">
                    learn more <span class="fas fa-chevron-right"></span>
                </a>
            </div>
            <div class="box">
                <i class="fas fa-user-md"></i>
                <h3>expert doctors</h3>
                <p>
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ad, omnis.
                </p>
                <a href=" " target="_blank" class="btn">
                    learn more <span class="fas fa-chevron-right"></span>
                </a>
            </div>
            <div class="box">
                <i class="fas fa-pills"></i>
                <h3>medicines</h3>
                <p>
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ad, omnis.
                </p>
                <a href=" " target="_blank" class="btn">
                    learn more <span class="fas fa-chevron-right"></span>
                </a>
            </div>
            <div class="box">
                <i class="fas fa-procedures"></i>
                <h3>bed facility</h3>
                <p>
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ad, omnis.
                </p>
                <a href=" " target="_blank" class="btn">
                    learn more <span class="fas fa-chevron-right"></span>
                </a>
            </div>
            <div class="box">
                <i class="fas fa-heartbeat"></i>
                <h3>total care</h3>
                <p>
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ad, omnis.
                </p>
                <a href=" " target="_blank" class="btn">
                    learn more <span class="fas fa-chevron-right"></span>
                </a>
            </div>
        </div>
    </section>
    {/* <section class="book" id="book">
    <h1 class="heading">Door step <span>services</span></h1>
    <div class="box-container">

    <p class="btext">
    We provide efficient and cost-
effective primary health care
services at your door step.
Our motto is to take
primary health care
services to the community
where it is needed the most.
                </p>
                
    </div>
    <button id="SER-btn" className="btn" onClick={navigateToServices}>Our Services</button>


    </section>  */}
    <section class="about" id="about">
        <h1 class="heading"><span>about</span> us</h1>
        <div class="row">
            <div class="image">
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT7Nd5QJdhzApS-CVTJD26Sgf1G1qxMo2WL7w&usqp=CAU"
                    alt="" />
            </div>
            <div class="content">
                <h3>we take care of your healthy life to live long ago..</h3>
                <p>
                    A doctor–patient relationship (DPR) is considered to be the core
                    element in the ethical principles of medicine. DPR is usually
                    developed when a physician tends to a patient’s medical needs via
                    check-up, diagnosis, and treatment in an agreeable manner. Due to
                    the relationship, the doctor owes a responsibility to the patient to
                    proceed toward the ailment or conclude the relationship
                    successfully. In particular, it is essential that primary care
                    physicians develop a satisfactory DPR in order to deliver prime
                    health care to patients
                </p>
                <p>
                    Trust in doctors allows patients to effectively discuss their health
                    issues. Development of trust enables the patient to comply with the
                    doctor’s guidance, which consequently results in improvement of
                    health.
                </p>
                <a href=" " class="btn">
                    learn more <span class="fas fa-chevron-right"></span>
                </a>
            </div>
        </div>
    </section>
    <section class="doctors" id="doctors">
        <h1 class="heading">our <span>doctors</span></h1>
        <div class="box-container">
            <div class="box">
                <img src={DR1} alt="" />
                <h3>DR1</h3>
                <span>SP1</span>
                <div class="share">
                    <a href="#" class="fab fa-facebook-f"></a>
                    <a href="#" class="fab fa-twitter"></a>
                    <a href="#" class="fab fa-instagram"></a>
                    <a href="#" class="fab fa-linkedin"></a>
                </div>
            </div>
            <div class="box">
                <img src={DR2} alt="" />
                <h3>DR2</h3>
                <span>SP2</span>
                <div class="share">
                    <a href="#" class="fab fa-facebook-f"></a>
                    <a href="#" class="fab fa-twitter"></a>
                    <a href="#" class="fab fa-instagram"></a>
                    <a href="#" class="fab fa-linkedin"></a>
                </div>
            </div>
            <div class="box">
                <img src={DR3} alt="" />
                <h3>DR3</h3>
                <span>SP3</span>
                <div class="share">
                    <a href="#" class="fab fa-facebook-f"></a>
                    <a href="#" class="fab fa-twitter"></a>
                    <a href="#" class="fab fa-instagram"></a>
                    <a href="#" class="fab fa-linkedin"></a>
                </div>
            </div>
            <div class="box">
                <img src={DR4} alt="" />
                <h3>DR4</h3>
                <span>SP4</span>
                <div class="share">
                    <a href="#" class="fab fa-facebook-f"></a>
                    <a href="#" class="fab fa-twitter"></a>
                    <a href="#" class="fab fa-instagram"></a>
                    <a href="#" class="fab fa-linkedin"></a>
                </div>
            </div>


        </div>
    </section>
   
    
    <section class="book" id="book">
        <h1 class="heading"><span>book</span> now</h1>
        <div class="row">
            <div class="image">
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQe8EVWGYBOy5hACG9G_sOzB1M4AkkVanaQbw&usqp=CAU"
                    alt="" />
            </div>
            <form name="google-sheet-form" method="post">
    <h2>Book Healthcare Service</h2>
    
    <input type="text" name="Name" placeholder="Your name" class="box" required/>
    
    <input type="tel" name="Number" placeholder="Your phone number" class="box" required maxLength={10}/>
    
    <input type="email" name="Email ID" placeholder="Your email" class="box" required/>
    
    <input type="date" name="Date" class="box" required/>
    
    <select name="TimeSlot" class="box" required>
        <option value="">Select a time slot</option>
        <option value="morning">Morning (9 AM - 12 PM)</option>
        <option value="afternoon">Afternoon (1 PM - 5 PM)</option>
        <option value="evening">Evening (6 PM - 9 PM)</option>
    </select>
    
    <select name="Gender" id="gender" class="box" required>
        <option value="">Select gender</option>
        <option value="Male">Male</option>
        <option value="Female">Female</option>

    </select>
    
    <select name="Service" class="box" required>
        <option value="">Select a service</option>
        <option value="doctor_visit">Doctor Visit</option>
        <option value="nurse_care">Nurse Care</option>
        <option value="physiotherapy">Physiotherapy</option>
        <option value="diagnostic_test">Diagnostic Test</option>
        <option value="medication_delivery">Medication Delivery</option>
    </select>
    
    <select name="Professional" class="box">
        <option value="">Select a professional (optional)</option>
        <option value="dr_smith">Dr. Smith (General Physician)</option>
        <option value="nurse_johnson">Nurse Johnson</option>
        <option value="physio_brown">Physiotherapist Brown</option>
    </select>
    
    <select name="ConsultationType" class="box" required>
        <option value="">Select consultation type</option>
        <option value="in_person">In-person</option>
        <option value="video">Video Consultation</option>
    </select>
    
    <textarea name="Message" rows="3" placeholder="Any additional information or special requests" class="box"></textarea>
    
    <label>
        <input type="checkbox" name="TermsAgreed" required/>
        <h1 class="taandc">I agree to the terms and conditions</h1>
    </label>
    
    <input type="submit" value="Book Now" class="btn"/>
</form>
        </div>
    </section>
    <section class="review" id="review">
        <h1 class="heading">client's <span>review</span></h1>
        <div class="box-container">
            <div class="box">
                <img src={bwImage}
                    alt="" />
                <h3>Black Widow</h3>
                <div class="stars">
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star-half-alt"></i>
                </div>
                <p class="text">
                    We consulted Dr. Venkata Harin Reddy sir for my father's Neuro
                    problem. The way he treated him and explained us the root cause and
                    his analysis is commendable. He has always been reachable and
                    responded to every query of ours with utmost patience.
                </p>
            </div>
            <div class="box">
                <img src={ironman}
                    alt="" />
                <h3>Iron Man</h3>
                <div class="stars">
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star-half-alt"></i>
                </div>
                <p class="text">
                    Dr. Madhu Thumu helped my Grand Mother, Dr. Mary Geetha Yeruva with
                    the knee replacement surgery on December 28, 2020.I speciaaly thank
                    to all   hospital staff for taking care of my Grand Mother
                    Treatment. Words are not sufficient to thank him enough for
                    restoring her from her knee problem...
                </p>
            </div>
            <div class="box">
                <img  src={cap}
                    alt="" />
                <h3>Captain America</h3>
                <div class="stars">
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star-half-alt"></i>
                </div>
                <p class="text">
                    I thank him and the entire medical team of  Hospital, Miyapur
                    that have assisted Geetha. The doctors, nurses, physiotherapists and
                    other staff members were wonderful and very friendly.excellent
                    surgeons who personally explains about the surgery and make the
                    surgery suceess.
                </p>
            </div>
        </div>
    </section>
    <section class="blogs" id="blogs">
        <h1 class="heading">our <span>blogs</span></h1>
        <div class="box-container">
            <div class="box">
                <div class="image">
                    <img src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8ZG9jdG9yfGVufDB8fDB8fA%3D%3D&w=1000&q=80"
                        alt="" />
                </div>
                <div class="content">
                    <div class="icon">
                        <a href="#"> <i class="fas fa-calendar"></i> 3rd oct, 2022 </a>
                        <a href="#"> <i class="fas fa-user"></i> by admin </a>
                    </div>
                    <h3>Doctor's Responsibilities Towards their Duty</h3>
                    <p>
                        Doctors have many duties toward their patients. Their
                        responsibilities cover their own actions, as well as orders they
                        give to their assistants, such as nurses, medical students and
                        residents.
                    </p>
                    <a href=" /reviews?procedure_id=4" class="btn">
                        learn more <span class="fas fa-chevron-right"></span>
                    </a>
                </div>
            </div>
            <div class="box">
                <div class="image">
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTcw1isR79Mb8rb-N7Xm3qdC1aAvdIQMxInYA&usqp=CAU"
                        alt="" />
                </div>
                <div class="content">
                    <div class="icon">
                        <a href="#"> <i class="fas fa-calendar"></i>3rd oct, 2022 </a>
                        <a href="#"> <i class="fas fa-user"></i> by admin </a>
                    </div>
                    <h3>Medical Doctors Job To Do Perform Diagonsis Test</h3>
                    <p>
                        It’s a medical doctor’s job to diagnose and treat patients to help
                        keep them at peak health. To do this, medical doctors perform
                        physical examinations, take and make note of a patient’s medical
                        history.
                    </p>
                    <a href=" /reviews?procedure_id=4" class="btn">
                        learn more <span class="fas fa-chevron-right"></span>
                    </a>
                </div>
            </div>
            <div class="box">
                <div class="image">
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR3SB-KgeYcBWfMC0Eddi4b5gPCqCNpg1Ymhi9SO9nV478eDxRNAIyKhT1hh8mFv9kRaS4&usqp=CAU"
                        alt="" />
                </div>
                <div class="content">
                    <div class="icon">
                        <a href="#"> <i class="fas fa-calendar"></i> 3rd oct, 2022 </a>
                        <a href="#"> <i class="fas fa-user"></i> by admin </a>
                    </div>
                    <h3>Consultanty Towards Doctor make your problem solved..</h3>
                    <p>
                        If a certain body part of your body is constantly troubling,
                        consultants can barely help. They can help reduce the pain or just
                        short-term relief. Specialists look forward to permanent and
                        long-term solutions.
                    </p>
                    <a href=" /reviews?procedure_id=4" class="btn">
                        learn more <span class="fas fa-chevron-right"></span>
                    </a>
                </div>
            </div>
        </div>
    </section>
    <section class="footer">
        <div class="box-container">
            <div class="box">
                <h3>quick links</h3>
                <a href="#"> <i class="fas fa-chevron-right"></i> home </a>
                <a href="#"> <i class="fas fa-chevron-right"></i> services </a>
                <a href="#"> <i class="fas fa-chevron-right"></i> about </a>
                <a href="#"> <i class="fas fa-chevron-right"></i> doctors </a>
                <a href="#"> <i class="fas fa-chevron-right"></i> book </a>
                <a href="#"> <i class="fas fa-chevron-right"></i> review </a>
                <a href="#"> <i class="fas fa-chevron-right"></i> blogs </a>
            </div>
            <div class="box">
                <h3>our services</h3>
                <a href="#"> <i class="fas fa-chevron-right"></i> dental care </a>
                <a href="#"> <i class="fas fa-chevron-right"></i> message therapy </a>
                <a href="#"> <i class="fas fa-chevron-right"></i> cardioloty </a>
                <a href="#"> <i class="fas fa-chevron-right"></i> diagnosis </a>
                <a href="#">
                    <i class="fas fa-chevron-right"></i> ambulance service
                </a>
            </div>
            <div class="box">
                <h3>contact info</h3>
                <a href="#"> <i class="fas fa-phone"></i> +91123456789 </a>
                <a href="#"> <i class="fas fa-phone"></i> +111-143-2000 </a>
                <a href="#">
                    <i class="fas fa-envelope"></i> sharathgungatte@gmail.com
                </a>
                <a href="#">
                    <i class="fas fa-envelope"></i> sharathgungatte@gmail.com
                </a>
                <a href="#">
                    <i class="fas fa-map-marker-alt"></i> bangalore, india - 500050
                </a>
            </div>
            <div class="box">
                <h3>follow us</h3>
                <a href="#"> <i class="fab fa-facebook-f"></i> facebook </a>
                <a href="#"> <i class="fab fa-twitter"></i> twitter </a>
                <a href="#"> <i class="fab fa-twitter"></i> twitter </a>
                <a href="#"> <i class="fab fa-instagram"></i> instagram </a>
                <a href="#"> <i class="fab fa-linkedin"></i> linkedin </a>
                <a href="#"> <i class="fab fa-pinterest"></i> pinterest </a>
            </div>
        </div>
    </section>
    <footer>
        <div class="end">
            copyrights &copy; reserved by <span>Sharath GM</span>
        </div>
    </footer>
   
</body>

</html>
  );
}



function AppointmentForm() {
  return (
    <div className="form-container">
      
    </div>
  );
}

export default App;
